import { NgIf, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IRowNode } from 'ag-grid-community';
import { PlotAttributes } from '~app/models';
type CheckpointDescriptionParams = {
  onCheckpointClick: (rowNode: IRowNode) => any;
  checkpointSubmitted: () => boolean;
};

@Component({
  selector: 'ciao-waypoint-name-cell-renderer',
  imports: [NgClass],
  template: `
    <div [ngClass]="{ hide: params?.node?.rowPinned }">
      <picture>
        <img
          [srcset]="getStatusImg(params?.data?.status)"
          [title]="getStatusHoverText(params?.data?.status)"
          alt="Checkpoint status icon"
        />
      </picture>
    </div>

    <p>{{ description }}</p>
  `,
  styles: `
    :host {
      display:flex;
      align-items: center;
    }
    p {
      margin: 0;
      line-height: 1.5;
      padding: .5em;
    }
    svg {
      margin-right: 12px;
      margin-bottom: 8px;
      &.hide {
        display: none;
      }
    }
  `,
})
export class CheckpointDescriptionCellRenderer
  implements ICellRendererAngularComp
{
  rowNode: IRowNode;
  params: ICellRendererParams & CheckpointDescriptionParams;
  description: string;
  agInit(
    params: ICellRendererParams<PlotAttributes, any> &
      CheckpointDescriptionParams
  ): void {
    this.refresh(params);
  }
  refresh(
    params: ICellRendererParams<PlotAttributes, any, any> &
      CheckpointDescriptionParams
  ) {
    this.params = params;
    this.rowNode = params?.node;
    this.description = params.data?.description;
    return true;
  }

  getStatusImg(status: string) {
    switch (status) {
      case 'Upcoming':
        return `assets/img/trip-2.0/checkpoint-status-icons/alarm.svg`;
      case 'Late':
        return `assets/img/trip-2.0/checkpoint-status-icons/emergency_home.svg`;
      case 'Missed':
        return `assets/img/trip-2.0/checkpoint-status-icons/block.svg`;
      case 'Submitted':
        return `assets/img/trip-2.0/checkpoint-status-icons/task_alt.svg`;
      default:
        return `assets/img/trip-2.0/checkpoint-status-icons/emergency_home.svg`;
    }
  }

  getStatusHoverText(status: string) {
    switch (status) {
      case 'Upcoming':
        return `Upcoming`;
      case 'Late':
        return `Late`;
      case 'Missed':
        return `Missed`;
      case 'Submitted':
        return `Submitted`;
      default:
        return `Late`;
    }
  }

  checkpointOnRow(rowNode, event: Event) {
    event.stopPropagation();
    if (this.params.onCheckpointClick) {
      this.params.onCheckpointClick(rowNode);
      return;
    }
    console.error('Things did not go well when clicking checkpoint thumbs up');
  }
}
